import { init as initCriticReviews } from '@theme/critic-reviews';

const SETUP_KEY = Symbol('accolades-metaobject-card');

/** @param {HTMLElement} card */
function setupCard(card) {
  const c = /** @type {any} */ (card);
  if (c[SETUP_KEY]) return;
  c[SETUP_KEY] = true;

  const tabs = /** @type {HTMLButtonElement[]} */ (
    Array.from(card.querySelectorAll('[data-accolades-tabs] button[role="tab"]'))
  );
  if (tabs.length < 2) return;

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => activateTab(card, tabs, tab, { focus: false }));
    tab.addEventListener('keydown', (event) => onTabKeydown(event, card, tabs, tab));
  });
}

/**
 * @param {KeyboardEvent} event
 * @param {HTMLElement} card
 * @param {HTMLButtonElement[]} tabs
 * @param {HTMLButtonElement} currentTab
 */
function onTabKeydown(event, card, tabs, currentTab) {
  const idx = tabs.indexOf(currentTab);
  /** @type {HTMLButtonElement | null} */
  let target = null;

  switch (event.key) {
    case 'ArrowLeft':
    case 'ArrowUp':
      target = tabs[(idx - 1 + tabs.length) % tabs.length] ?? null;
      break;
    case 'ArrowRight':
    case 'ArrowDown':
      target = tabs[(idx + 1) % tabs.length] ?? null;
      break;
    case 'Home':
      target = tabs[0] ?? null;
      break;
    case 'End':
      target = tabs[tabs.length - 1] ?? null;
      break;
    default:
      return;
  }

  event.preventDefault();
  activateTab(card, tabs, target, { focus: true });
}

/**
 * @param {HTMLElement} card
 * @param {HTMLButtonElement[]} tabs
 * @param {HTMLButtonElement | null} tab
 * @param {{ focus: boolean }} options
 */
function activateTab(card, tabs, tab, { focus }) {
  if (!tab) return;

  const index = tab.dataset.vintageIndex;
  if (index == null) return;

  tabs.forEach((t) => {
    const active = t === tab;
    t.classList.toggle('accolades-card__tab--active', active);
    t.setAttribute('aria-selected', active ? 'true' : 'false');
    t.setAttribute('tabindex', active ? '0' : '-1');
  });

  if (focus) tab.focus();

  card.querySelectorAll('[data-vintage-image], [data-vintage-panel]').forEach((el) => {
    el.toggleAttribute('hidden', /** @type {HTMLElement} */ (el).dataset.vintageIndex !== index);
  });

  // The revealed panel's critic-reviews slideshow was measured at height 0
  // while hidden — re-run setup and trigger a resync so it sizes correctly.
  requestAnimationFrame(() => {
    initCriticReviews();
    window.dispatchEvent(new Event('resize'));
  });
}

function init() {
  document.querySelectorAll('[data-accolades-card]').forEach((el) => setupCard(/** @type {HTMLElement} */ (el)));
}

const win = /** @type {any} */ (window);
if (!win.__accoladesMetaobjectBound) {
  win.__accoladesMetaobjectBound = true;
  document.addEventListener('shopify:section:load', init);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
